import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import { useBundle } from '@amzn/react-arb-tools';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { RegularButton, YellowButton } from 'src/common/buttons';
import { useBagStore } from 'src/store';
import { getOneClickReturnPath } from 'src/utils/paymentSelectionUtils';
export const EmptyPaymentSelectionBody = ({ refetch }) => {
    const [bundle, isBundleLoading] = useBundle('pages.paymentSelectionPage');
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { listBag } = useBagStore();
    if (isBundleLoading)
        return null;
    const handleBack = () => {
        var _a, _b;
        const search = `?${searchParams.toString()}`;
        navigate((_b = getOneClickReturnPath(search, (_a = listBag()[0]) === null || _a === void 0 ? void 0 : _a.asin)) !== null && _b !== void 0 ? _b : `/checkout/preview${search}`);
    };
    return (_jsxs("div", { "data-testid": "empty-payment-selection", children: [_jsx(Column, { spacingInset: "none 350", children: _jsx(Text, { children: bundle.getMessage('addPaymentMethod') }) }), _jsxs(Column, { spacingInset: "400 350", spacing: "300", children: [_jsx(YellowButton, { onClick: refetch, "data-testid": "retry-button", children: bundle.getMessage('retry') }), _jsx(RegularButton, { onClick: handleBack, "data-testid": "back-button", children: bundle.getMessage('back') })] })] }));
};
